<template>
  <div class="delete-account">
    <ba6-modal modal-id="modal-delete-account">
      <div v-if="!IsEmpty(steps)" class='ba-card ba-jc-sb ba-w-100 ba-no-shadow'>

        <!-- Header -->
        <div class='ba-top'>
          <div>
            <span class='ba-title' style="color: #0072e1;">{{ selectedData.header.title }}</span>
            <builderall-loader
              :loading="loading" class="ba-w-100"
            >
              <span v-if="!IsEmpty(selectedData.header.subtitle)"
                    class="ba-subtitle ba-flex"
                    :style="{ color: selectedData.footer.backOpt == 'cancel' ? '#FA4B57' : '#111827' }"
                    v-html="selectedData.header.subtitle"
              />
            </builderall-loader>
          </div>
          <div class='ba-box-items ba-flex ba-gp-1'>
            <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="closeModal">
              <builderall-icon code='64f7' />
            </button>
          </div>
        </div>

        <builderall-loader
          :loading="loading" class="ba-w-100"
        >
          <!-- Body -->
          <pause-body
            :t="t"
            :step="selectedData"
            :questions="questions"
            :set-questions="setQuestions"
            :pause="changePage"
            :view="view"
          />
        </builderall-loader>

        <!-- Footer -->
        <div class="ba-content-footer ba-w-100 ba-flex ba-fd-rr ba-jc-sb">
          <a :class="[selectedData.footer.backOpt == 'pause_back' ? 'ba-btn ba-md ba-blue' :
                      selectedData.footer.backOpt == 'cancel' ? 'ba-btn ba-md ba-red' : 'ba-color-black11 footer-button']"
             @click="changePage(selectedData.footer.opt)">{{ selectedData.footer.next }}
          </a>
          <a v-show="!IsEmpty(selectedData.footer.back)"
             class="ba-color-black11 footer-button"
             @click="changePage(selectedData.footer.backOpt)">{{ selectedData.footer.back }}
          </a>
        </div>

      </div>
    </ba6-modal>
  </div>
</template>

<script>
export default {
  name: 'pause-modal',
  props: ['view', 'currentInvoice', 'invoicesData'],
  data() {
    return {
      disableClick: true,
      t: null,
      steps: null,
      questions: null,
      questionSelected: null,
      pauseData: null,
      loading: false,
      pauseAmount: null
    }
  },
  created() {
    this.t = this.view.translation

    this.getPauseAccountData()
    if (this.IsEmpty(this.questions)) {
      this.getQuestions()
    }

    console.log(this)
  },
  methods: {
    closeModal() {
      $('#modal-delete-account').toggle('hide');
    },
    currencySymbol (moeda) {
      var val = moeda
      switch (moeda.toLowerCase()) {
        case 'brl':
          val = 'R$'
          break;
        case 'usd':
          val = '$'
          break;
        case 'eur':
          val = '€'
          break;
        case 'gbp':
          val = '£'
          break;
        case 'czk':
          val = 'Kč'
          break;
        case 'inr':
          val = '€'
          break;
        case 'thb':
          val = '฿'
          break;
      }
      return val
    },
    cancelRecurrence() {
      this.loading = true
      let vm = this

      axios.post(`${this.invoicesData.cancelRoute}/${this.currentInvoice.id}`)
        .then(response => {
          alertMsg('success', this.t.label_pagamento_recorrente_cancelado)

          this.saveQuestions();

          setTimeout(() => {
            window.location.reload()
          }, 500)
        })
        .catch(({response}) => {
          alertMsg('error', response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    changePage(opt) {
      let currentStep = this.steps[this.steps.findIndex(x => x.status == true)].step;
      let step = null

      switch (opt) {
        case 'next':
          step = currentStep++
          this.setStep(currentStep)

          break;
        case 'cancel':
          this.cancelRecurrence()

          break;
        case 'paypal':
          window.open(this.pauseData.checkout_url, '_self')

          break;
        case 'back':
          step = opt == 'pause_back' ? currentStep = 2 : currentStep--
          this.setStep(currentStep)

          break;
        case 'pause_back':
          step = opt == 'pause_back' ? currentStep = 2 : currentStep--
          this.setStep(currentStep)

          break;
        case 'pause_account':
          step = 0
          isEmpty(this.pauseData.checkout_url) ? step = 5 : step = 6
          this.setStep(step)

          break;
        case 'pause':
          this.pauseAccount()

          break;
        case 'questions':
          if(isEmpty(this.questionSelected)){
            alertMsg('error', this.t.link_generator_choose_an_option)
          }else{
            if(this.questionSelected.answer_type == 'TEXT' && isEmpty(this.questionSelected.answer)){
              alertMsg('error', this.t.describe_your_reason)
            }else{
              step = 4
              this.setStep(step)
            }
          }

          break;
      }
    },
    setStep(step) {
      this.steps.forEach(x => {
        x.status = step === x.step
      })
    },
    saveQuestions() {
      this.loading = true
      let vm = this;

      const formData = new FormData();
      formData.append('question_id', this.questionSelected.question_id);
      formData.append('answer_id', this.questionSelected.id);
      formData.append('lang', this.view.user_data.pais);
      formData.append('currency', this.view.user_data.plano_currency);
      formData.append('answer', isEmpty(this.questionSelected.answer) ? '' : this.questionSelected.answer);

      const headers = {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      };

      axios
        .post(`/${vm.view.user_data.pais}/office/question-management-feedback`, formData, headers)
        .then(response => {
          let status = response.data.success ? 'success' : 'error'

          response.data.success ? this.setStep(4) : null
        })
        .catch(error => {
          console.error('Erro:', error);
        })
        .finally(() => {
          vm.loading = false
        })
    },
    pauseAccount() {
      let vm = this
      this.loading = true

      axios
        .post(`/${vm.view.user_data.pais}/office/pause-account`)
        .then(response => {
          if (response.data.success) {
            let alert = vm.t.pause_account_requested_successfully.replace('{date}', response.data.data.pause_date)

            alertMsg('success', alert)
            setTimeout(() => {
              window.open(`${vm.view.handler_routes.route_office_info}?tab=invoices`, '_self')
            }, 3000)
          }
        })
        .catch(error => {
          alertMsg('error', error.message)
        })
        .finally(() => {
          vm.loading = false
        });
    },
    getPauseAccountData() {
      this.loading = true
      let vm = this

      axios.get(`/${vm.view.user_data.pais}/office/pause-account`)
        .then(response => {
          vm.pauseData = response.data.data
        })
        .finally(() => {
          vm.afterGetData()
          vm.loading = false
        })
    },
    pauseValue() {
      let symbol = isEmpty(this.pauseData.currency) ? 'usd' : this.pauseData.currency.toLowerCase(),
          pauseVal = this.currencySymbol(symbol) + this.pauseData.pause_value;

      this.pauseAmount = pauseVal
    },
    async afterGetData() {
      await this.pauseValue()

      this.t.label_cancel_description = this.t.label_cancel_description.replace('{valid}', this.pauseData.pause_date)
      this.t.label_pause_description = this.t.label_pause_description.replace('{valid}', this.pauseData.pause_date).replace('{val}', this.pauseAmount)
      this.t.label_keep_your_account = this.t.label_keep_your_account.replace('{val}', this.pauseAmount)

      this.steps = [
        { step: 1, status: true, header: { title: this.t.dont_leave, subtitle: '' }, footer: { back: '', next: this.t.continue_recurrence_cancellation, opt: 'next', backOpt: '' } },
        { step: 2, status: false, header: { title: this.t.need_break, subtitle: '' }, footer: { back: this.t.dns_back, next: this.t.cancel_anyway, opt: 'next', backOpt: 'back' }  },
        { step: 3, status: false, header: { title: this.t.well_miss_you, subtitle: this.t.tell_us_more_leaving }, footer: { back: this.t.dns_back, next: this.t.cancel_confirmation_label, opt: 'questions', backOpt: 'back' }  },
        { step: 4, status: false, header: { title: this.t.cancel_recurrency, subtitle: this.t.label_cancel_description }, footer: { back: '', next: this.t.label_confirm, opt: 'cancel', backOpt: 'cancel' }  },
        { step: 5, status: false, header: { title: this.t.account_pause, subtitle: '' }, footer: { back: this.t.dns_cancel, next: this.t.label_confirm, opt: 'pause', backOpt: 'pause_back' }  },
        { step: 6, status: false, header: { title: this.t.payment_method_change, subtitle: '' }, footer: { back: this.t.dns_back, next: this.t.label_confirm, opt: 'paypal', backOpt: 'pause_back' }  },
      ]
      this.loading = false
    },
    IsEmpty(val) {
      return isEmpty(val)
    },
    getQuestions() {
      let vm = this,
          context = 'recurrence_cancel';

      axios
          .get(`/${vm.view.user_data.pais}/office/question-management/${context}`)
          .then((res) => {
            vm.questions = res.data.data
          })
          .catch((eror) => {
            alertMsg('error', error.message)
          })
    },
    setQuestions(val) {
      this.questionSelected = val
    }
  },
  computed: {
    selectedData() {
      let selectedData = !isEmpty(this.steps) ? this.steps[this.steps.findIndex(x => x.status)] : null

      return selectedData
    },
  }
}
</script>

<style>
.modal-delete-account {
  width: 665px !important;
}
.default-border {
  border-radius: 16px;
  border: 1px solid #E4EAF6;
}
.font-16 {
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 600;
  line-height: 25.6px;
}
.font-14 {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 21.98px;
}
.ba-w-30 {
  width: 30%;
}
.footer-button {
  text-transform: uppercase;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 700;
}
.ba-fd-rr {
  flex-direction: row-reverse;
}
.ba-subtitle {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
}
.delete {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #E4EAF6;
}
.ba6-profile-modal {
  top: 4.5px !important;
  max-height: 90vh;
  overflow: auto;
}
</style>




// WEBPACK FOOTER //
// resources/office/js/components/office-v6/pause-account/modal.vue